import { memoizeFunction } from '@agilepoint/utils-common';
import styled from 'styled-components';
import { ISeparatorProps } from '../separator.types';
import { isVerticalOrientation } from '../utils';

interface IBeakProps extends Pick<ISeparatorProps, 'inverseBeak' | 'orientation' | 'beakColor'> {
}

const getBeakDirection = memoizeFunction((orientation: 'horizontal' | 'vertical', isInverse?: boolean) => {
    if (isVerticalOrientation(orientation)) {
        if (isInverse) {
            return 'rotate(225deg)';
        }
        return 'rotate(45deg)';
    }
    if (isInverse) {
        return 'rotate(315deg)';
    }
    return 'rotate(135deg)';
});

export const Beak = styled.div.attrs(() => ({
    className: String('ap-wc-separatorBeak')
})) <IBeakProps>`
    position: absolute;
    width: 15px;
    height: 15px;
    left: ${({ orientation }) => (isVerticalOrientation(orientation!) ? '-7px' : 'unset')};
    top: ${({ orientation }) => (isVerticalOrientation(orientation!) ? 'unset' : '-7px')};
    transform: ${({ inverseBeak, orientation }) => getBeakDirection(orientation!, inverseBeak)};
    background-color: ${({ beakColor, theme: { semantics: { palette } } }) => beakColor ?? palette.white};
    border-top: 1px solid ${({ color, theme: { semantics: { palette } } }) => color ?? palette.black};
    border-right: 1px solid ${({ color, theme: { semantics: { palette } } }) => color ?? palette.black};
`;
